import { last } from "lodash";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useEffectOnce, useTitle } from "react-use";
import useTranslations from "./useTranslations";

export type BreadcrumbData = {
  to: string;
  text: string;
};
export const BreadcrumbContext = createContext<{
  breadcrumbs: BreadcrumbData[];
  setBreadcrumbs;
}>({
  breadcrumbs: [],
  setBreadcrumbs: null,
});

export const BreadcrumbProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbData[]>([
    {
      to: "/dashboard",
      text: "Dashboard",
    },
  ]);

  useTitle(
    last(breadcrumbs)?.text ? `${last(breadcrumbs)?.text} - Klara` : "Klara"
  );

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = (items: BreadcrumbData[]) => {
  const t = useTranslations();
  const { breadcrumbs, setBreadcrumbs } = useContext(BreadcrumbContext);

  useEffect(() => {
    setBreadcrumbs([
      { to: "/dashboard", text: t("header.dashboard") as string },
      ...items,
    ]);
  }, [JSON.stringify(items)]);

  return breadcrumbs;
};
